module.exports = __webpack_public_path__ + "0fdbe23994db90c55d9a725437daa283.svg";